<template>
  <div>
    <validation-observer ref="endTripRef">
      <b-form
        autocomplete="off"
        @submit.prevent="endTrip"
      >
        <b-row>
          <b-col
            md="12"
          >
            <validation-provider
              name="Distance"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Distance"
                label-for="end-trip-distance"
              >
                <b-input-group>
                  <b-form-input
                    id="end-trip-distance"
                    v-model="endData.distance"
                    type="number"
                    placeholder="Distance"
                  />
                  <b-input-group-append>
                    <b-input-group-text class="bg-transparent">
                      <b>KM</b>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
                <span class="text-danger absolute">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              name="Date"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Date"
                label-for="end-trip-date"
              >
                <b-form-datepicker
                  id="end-trip-date"
                  v-model="endDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              name="Time"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Time"
                label-for="end-trip-time"
              >
                <b-form-timepicker
                  id="end-trip-time"
                  v-model="endTime"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-col
          md="12"
          class="p-0"
        >
          <b-button
            block
            type="submit"
            variant="primary"
            :disabled="submitting"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <span v-else>End Trip</span>
          </b-button>
        </b-col>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import {
  BButton, BRow, BCol, BFormInput, BForm, BFormGroup, BSpinner, BFormDatepicker, BFormTimepicker, BInputGroup, BInputGroupAppend, BInputGroupText,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'

export default {
  components: {
    BFormGroup,
    BForm,
    BFormInput,
    BButton,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BFormDatepicker,
    BFormTimepicker,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
  },
  setup(_, ctx) {
    const submitting = ref(false)
    const endTripRef = ref(null)
    const endDate = ref(null)
    const endTime = ref(null)

    const endData = ref({
      distance: null,
      endTime: null,
    })
    const canEnd = computed(() => {
      if (endData.value.distance && endData.value.endtime) {
        return true
      }
      return false
    })
    const endTrip = async () => {
      ctx.emit('ending')
      submitting.value = true
      await ctx.root.$store.dispatch('trips/applyActionOnTrip', {
        action: 'end',
        actionDescription: undefined,
        actualDropoff: undefined,
        data: endData.value,
      })
      submitting.value = false
      ctx.root.$bvModal.hide('end-trip-modal')
    }

    watch([endDate, endTime], () => {
      console.log(endDate.value)
      console.log(endTime.value)
      if (endDate.value && endTime.value) {
        endData.value.endTime = new Date(`${endDate.value} ${endTime.value}`).toISOString()
      }
    })
    return {
      required,
      endTripRef,
      endTrip,
      submitting,
      endDate,
      endTime,
      endData,
      canEnd,
    }
  },
}
</script>

<style>

</style>
